/**
 * @file FilterBar.jsx
 * @description FilterBar component for displaying and managing filter bar.
 * @component FilterBar
 * @exports FilterBar - Main component for displaying and managing filter bar.
 */

import React from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { TEXT_STRING } from "../../../common/constants/agentModule/textConstants";
import { SIZES, VARIANTS } from "../../../common/constants/commonConstants";
import Grid from "@mui/material/Grid2";

const FilterBar = ({
  searchTerm,
  setSearchTerm,
  filterStatus,
  setFilterStatus,
  filterReview,
  setFilterReview,
  filterAssignedTo,
  setFilterAssignedTo,
}) => {
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      {/* Search Field */}
      <Grid size={SIZES.GROW}>
        <TextField
          sx={{ fontSize: "14px" }}
          fullWidth
          label={TEXT_STRING.TEXT_SEARCH_CUSTOMER_PLACEHOLDER}
          variant={VARIANTS.OUTLINED}
          size={SIZES.SMALL}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Grid>

      {/* Assigned To Filter */}
      <Grid size={SIZES.AUTO}>
        <FormControl
          variant={VARIANTS.OUTLINED}
          size={SIZES.SMALL}
          sx={{ minWidth: 160 }}
        >
          <InputLabel>{TEXT_STRING.ASSIGN_TO_PLACEHOLDER}</InputLabel>
          <Select
            sx={{ fontSize: "14px" }}
            value={filterAssignedTo}
            onChange={(e) => setFilterAssignedTo(e.target.value)}
            label={TEXT_STRING.ASSIGN_TO_PLACEHOLDER}
          >
            <MenuItem sx={{ fontSize: "14px" }} value={-1}>Select Assign To</MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} value={0}>Me</MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} value={1}>Others</MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} value={2}>Unassigned</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {/* Review Status Filter */}
      <Grid size={SIZES.AUTO}>
        <FormControl
          variant={VARIANTS.OUTLINED}
          size={SIZES.SMALL}
          sx={{ minWidth: 160 }}
        >
          <InputLabel>{TEXT_STRING.REVIEW_PLACEHOLDER}</InputLabel>
          <Select
            sx={{ fontSize: "14px" }}
            value={filterReview}
            onChange={(e) => setFilterReview(e.target.value)}
            label={TEXT_STRING.REVIEW_PLACEHOLDER}
          >
            <MenuItem sx={{ fontSize: "14px" }} value={0}>Needs Review</MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} value={1}>Review Complete</MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} value={2}>All</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      {/* Status Filter */}
      <Grid size={SIZES.AUTO}>
        <FormControl
          variant={VARIANTS.OUTLINED}
          size={SIZES.SMALL}
          sx={{ minWidth: 140 }}
        >
          <InputLabel>{TEXT_STRING.STATUS_PLACEHOLDER}</InputLabel>
          <Select
            sx={{ fontSize: "14px" }}
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            label={TEXT_STRING.STATUS_PLACEHOLDER}
          >
            <MenuItem sx={{ fontSize: "14px" }} value={0}>Active</MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} value={1}>Inactive</MenuItem>
            <MenuItem sx={{ fontSize: "14px" }} value={2}>All</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default FilterBar;
